import { render, staticRenderFns } from "./BoMitraPage.vue?vue&type=template&id=11e72e21&scoped=true"
import script from "./BoMitraPage.vue?vue&type=script&lang=js"
export * from "./BoMitraPage.vue?vue&type=script&lang=js"
import style0 from "./BoMitraPage.vue?vue&type=style&index=0&id=11e72e21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e72e21",
  null
  
)

export default component.exports